import ReactApexChart from "react-apexcharts";
import Skeleton from "react-loading-skeleton";
import { FaBed, FaCheckCircle } from "react-icons/fa"; 

const HospitalBedChart = ({ totalBeds, occupiedBeds, isLoading }) => {
  if (isLoading) {
    return <Skeleton height={400} />;
  }

  const availableBeds = totalBeds - occupiedBeds;
  const labels = ['Occupied', 'Available'];
  const series = [occupiedBeds, availableBeds];
  const chartColors = ['#F59E0B', '#465DFF'];

  const chartState = {
    series: series,
    options: {
      chart: { type: 'donut' },
      labels: labels,
      colors: chartColors,
      legend: { show: false },
      dataLabels: { enabled: false },
      plotOptions: {
        pie: {
          donut: {
            size: "75%",
            labels: {
              show: true,
              name: { show: false },
              value: {
                show: true,
                fontSize: '24px',
                fontWeight: 'bold',
                offsetY: 8,
              },
              total: {
                show: true,
                label: 'Total Beds',
                fontSize: '16px',
                fontWeight: 600,
                color: '#373d3f',
                formatter: () => totalBeds.toLocaleString(),
              },
            },
          },
        },
      },
    },
  };

  const breakdownData = [
    {
      name: 'Occupied Beds',
      count: occupiedBeds,
      percentage: totalBeds > 0 ? ((occupiedBeds / totalBeds) * 100).toFixed(2) : "0.00",
      icon: <FaBed />,
      color: 'text-orange-500',
      bgColor: 'bg-orange-100',
    },
    {
      name: 'Available Beds',
      count: availableBeds,
      percentage: totalBeds > 0 ? ((availableBeds / totalBeds) * 100).toFixed(2) : "0.00",
      icon: <FaCheckCircle />,
      color: 'text-blue-500',
      bgColor: 'bg-blue-100',
    },
  ];

  return (
    <div>
      {/* Chart Component */}
      <div id="chart" className="dashboard-donut-chart">
        <ReactApexChart options={chartState.options} series={chartState.series} type="donut" height={220} />
      </div>

      <div className="mt-6 flex justify-center items-center gap-6 sm:gap-10">
        {breakdownData.map((item, index) => (
          <div key={index} className="flex flex-col items-center text-center">
            <p className="text-sm font-medium text-gray-500">{item.name}</p>
            <div className={`flex items-center gap-2 my-1 ${item.color}`}>
              <span className="text-2xl">{item.icon}</span>
              <p className="text-3xl font-bold text-gray-800">{item.count}</p>
            </div>
            <div className={`${item.bgColor} ${item.color} text-xs font-bold px-2 py-1 rounded`}>
              {item.percentage}%
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HospitalBedChart;